import he from 'he';

/**
 * Repeatedly HTML-entity-decodes a string until it stops changing, capped at `maxIterations`.
 * Repairs values that were accidentally multi-encoded (e.g. `&amp;quot;` from a past round-trip
 * bug) while being a no-op for already-clean text.
 * @param {string} value
 * @param {number} [maxIterations]
 * @returns {string}
 */
export const decodeHtmlEntitiesDeep = (value, maxIterations = 5) => {
  if (!value) return value ?? '';

  let current = value;
  for (let i = 0; i < maxIterations; i += 1) {
    const decoded = he.decode(current);
    if (decoded === current) break;
    current = decoded;
  }
  return current;
};
